export default "__VITE_ASSET__6d9bd9cb__"